import React, { useState } from 'react';
import styles from './Navbar.module.css';
import logo from '../../assets/logo.webp';
import { Link } from 'react-router-dom';

const Dropdown = () => {
  return (
    <ul className={styles.dropdown}>
      <li>
        <Link to="2019">2019</Link>
      </li>
      <li>
        <Link to="2018">2018</Link>
      </li>
      <li>
        <Link to="2017">2017</Link>
      </li>
    </ul>
  );
};

const Navbar = () => {
  const [isShown, setIsShown] = useState(false);

  const isShownHandler = () => {
    setIsShown(prevState => !prevState);
  };

  return (
    <nav className={styles.navbar}>
      <Link to="/">
        <img className={styles.logo} src={logo} alt="synergy youth logo" />
      </Link>
      <ul className={styles.links}>
        <li className={styles.link}>
          <a href="#home">首頁</a>
        </li>
        <li className={styles.link}>
          <a href="#about">關於我們</a>
        </li>
        <li
          className={styles.link}
          onMouseEnter={isShownHandler}
          onMouseLeave={isShownHandler}
        >
          <a href="#events">交流活動&#9660;</a>
          {isShown && <Dropdown />}
        </li>
        <li className={styles.link}>
          <a href="#contact">聯絡我們</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
